import { EventTextSizes } from '@/types/gql.generated';
import { SidebarRowSelect } from '../SidebarRowSelect';
import { useCustomizeControl } from '../useCustomizeControl';

const TEXT_SIZE_OPTIONS = [
  { id: EventTextSizes.Default, label: 'Default' },
  { id: EventTextSizes.Large, label: 'Large' },
];

export const TextSizeSelect = () => {
  const { register } = useCustomizeControl();

  return (
    <SidebarRowSelect
      minW="140px"
      options={TEXT_SIZE_OPTIONS}
      {...register('child', 'eventTextSize')}
    />
  );
};
